import { RISK_GRADES } from '../action';
const initialState = {
    riskGrades: null
};
const riskGradesReducer = (state = initialState, action) => {
    switch (action.type) {
        case RISK_GRADES:
            return state = {
                ...state,
                riskGrades: action.data
            }
        default:
            return state
    }
}
export default riskGradesReducer;